module.exports = __webpack_public_path__ + "static/media/right-curve-image.4716915f.svg";